@charset "UTF-8";

/* src/app/acs-chat/components/message-bubble/message-bubble.scss */
.bubble-row {
  display: flex;
  margin: 6px 16px;
}
.bubble-row.mine {
  justify-content: flex-end;
}
.bubble-row.theirs {
  justify-content: flex-start;
}
.bubble {
  max-width: 85%;
  min-width: 200px;
  padding: 10px 14px;
  border-radius: 10px;
  position: relative;
  word-wrap: break-word;
  line-height: 1.45;
  font-size: 14px;
  background: #fff;
  border: 1px solid #ddd;
  color: #333;
}
.bubble.sent {
  background: #f0f7ff;
  border-color: #c5d9ed;
}
.bubble.received {
  background: #fff;
  border-color: #ddd;
}
.bubble-header {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  margin-bottom: 4px;
}
.sender-name {
  font-size: 13px;
  font-weight: 700;
  color: #333;
}
.time {
  font-size: 11px;
  color: #999;
}
.bubble-text {
  margin: 0;
  white-space: pre-wrap;
  color: #444;
  font-size: 14px;
  line-height: 1.5;
}
.bubble-meta {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 4px;
  margin-top: 4px;
}
.bubble-meta .status {
  font-size: 11px;
  color: #999;
}
.bubble-meta .status.read {
  color: #5ba4b5;
}
/*# sourceMappingURL=message-bubble.css.map */
